import { Component, OnInit,  Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { TicketsService } from '../../tickets.service';
import { EmpleadoService } from 'src/app/empleado/empleado.service';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { SoloNumeroEnteroDirective } from '../../../utilerias/directives/solo-numero-entero.directive';
import { MatCardActions } from '@angular/material/card';

@Component({
    selector: 'app-modal-prioridad',
    standalone: true,
    templateUrl: './modal-prioridad.component.html',
    imports: [MatIconButton, MatIcon, MatFormField, MatInput, FormsModule, SoloNumeroEnteroDirective, MatCardActions, MatButton]
})
export class ModalPrioridadComponent implements OnInit {

  prioridad: Prioridad;

  constructor(private router: Router, private route: ActivatedRoute,
      @Inject(MAT_DIALOG_DATA) public objectPrioridad: Prioridad,
      public dialogRef: MatDialogRef<any>, private msg: Msg, private ticketsService: TicketsService, private empleadoService: EmpleadoService){

  }

  ngOnInit() {
    if(this.objectPrioridad == null){
      this.prioridad = new Prioridad();
      
  }else{
      console.log('this.objectArea :::', this.objectPrioridad);
      this.prioridad = this.objectPrioridad;
  }
  }


  guardarActualizar(){
    if( this.validarFormulario()){
        
        console.log('this.area :::', this.prioridad);
        this.ticketsService.editarPrioridad(this.prioridad).subscribe(res =>{
            ;
            if(+res.pCodRetorno==0){
                this.msg.successCall("Prioridad editada con éxito.", null, res =>  this.dialogRef.close(this.prioridad));
                this.prioridad = res;
            }else{
                // 00002: sin permiso (solo el gestor de plataforma edita el catalogo, que es de todos los clientes).
                this.msg.warningCall(+res.pCodRetorno == 2 && res.pMensaje ? res.pMensaje : "No se pudo editar la prioridad.", null, null);
            }
        });
    }else{
        this.msg.warningCall("Campos vacíos, favor de validar el formulario", null, null);
    }
}

validarFormulario(): boolean{
  
  if(this.prioridad.tiempo_en_horas== null || this.prioridad.tiempo_en_horas == 0 || this.prioridad.tiempo_en_horas== undefined)
  return false;

  return true;
}
  back(){
    this.dialogRef.close();
}
}
